<div class="d-flex justify-content-between">
  <div class="date-picker-container">
    <button
      im-icon-button
      class="sm"
      [disabled]="isPreviousDisabled"
      [attr.aria-label]="'consumption_header_previous_button_l_a11y' | translate"
      (click)="selectPreviousPeriod()"
    >
      <rs-web-icon
        primary
        [icon]="ImmomioIconName.ArrowLeft"
        [size]="14"
        [color]="iconColor"
      ></rs-web-icon>
    </button>

    <span class="date-picker-text" [class.month]="isMonthSelected">
      {{ date | date: dateFormat }}
    </span>

    <button
      im-icon-button
      class="sm"
      [disabled]="isNextDisabled"
      [attr.aria-label]="'consumption_header_next_button_l_a11y' | translate"
      (click)="selectNextPeriod()"
    >
      <rs-web-icon
        primary
        [icon]="ImmomioIconName.ArrowRight"
        [size]="14"
        [color]="iconColor"
      ></rs-web-icon>
    </button>
  </div>
  @if (isMonthAvailable) {
    <div class="d-flex flex-row gap-2">
      <div
        class="date-picker-toggle-item"
        [class.active]="isMonthSelected"
        (click)="timeframeChange.emit(ConsumptionTimeframe.MONTH)"
      >
        <span>{{ 'month' | translate }}</span>
      </div>
      <div
        class="date-picker-toggle-item"
        [class.active]="!isMonthSelected"
        (click)="timeframeChange.emit(ConsumptionTimeframe.YEAR)"
      >
        <span>{{ 'year' | translate }}</span>
      </div>
    </div>
  }
</div>
